import { get, set, del } from 'idb-keyval';

/**
 * Creates an Indexed DB persister
 * @see https://tanstack.com/query/latest/docs/framework/react/plugins/persistQueryClient#createidbkeyvalpersister
 */
export function createIDBPersister(idbValidKey = 'reactQuery') {
    return {
        persistClient: async (client) => {
            try {
                await set(idbValidKey, client);
            } catch (error) {
                console.error("Persist failed", error);
            }
        },
        restoreClient: async () => {
            try {
                return await get(idbValidKey);
            } catch (error) {
                console.error("Restore failed", error);
                return undefined;
            }
        },
        removeClient: async () => {
            await del(idbValidKey);
        },
    };
}
